<script setup lang="ts">
import { toggleActions } from "@/action/toggleActions";
import { action } from "@/components/action/action";
import IconButton from "@/components/ui/IconButton/IconButton.vue";
import InfoMarker from "@/components/ui/InfoMarker/InfoMarker.vue";
import { useSearchMenuStore } from "@/store/search/searchMenu";

import ArtItemTooltip from "./tooltips/ArtItemTooltip.vue";
import AssigneeItemTooltip from "./tooltips/AssigneeItemTooltip.vue";
import DependencyLinkItemTooltip from "./tooltips/DependencyLinkItemTooltip.vue";
import IterationItemTooltip from "./tooltips/IterationItemTooltip.vue";
import ReporterItemTooltip from "./tooltips/ReporterItemTooltip.vue";
import RiskyLinksItemTooltip from "./tooltips/RiskyLinksItemTooltip.vue";
import StatusItemTooltip from "./tooltips/StatusItemTooltip.vue";
import StickersItemTooltip from "./tooltips/StickersItemTooltip.vue";
import StickyTypeItemTooltip from "./tooltips/StickyTypeItemTooltip.vue";
import TeamItemTooltip from "./tooltips/TeamItemTooltip.vue";
import UpperLevelLinksTooltip from "./tooltips/UpperLevelLinksTooltip.vue";

const store = useSearchMenuStore();
</script>

<template>
  <div style="position: relative">
    <!-- eslint-disable-next-line vuejs-accessibility/click-events-have-key-events vuejs-accessibility/no-static-element-interactions-->
    <IconButton
      id="search-bar-trigger"
      aria-expanded="false"
      v-bind="action(toggleActions.toggleSearch)"
    >
      <template #tooltip>
        <div v-if="!store.anyFilterCriteria">
          {{ $t("action.search") }}
        </div>
        <template v-else>
          <div v-if="store.text">
            {{ $t("general.text") }}
            <div class="shortcut">
              {{ store.text }}
            </div>
          </div>
          <StickyTypeItemTooltip
            v-if="store.selectedStickyTypes.length"
            :types="store.selectedStickyTypes"
          />
          <DependencyLinkItemTooltip
            v-if="store.selectedDependencyLinkItems.length"
            :items="store.selectedDependencyLinkItems"
          />
          <StickersItemTooltip v-if="store.flags.length" :stickers="store.flags" />
          <IterationItemTooltip
            v-if="store.selectedIterations.length"
            :iterations="store.selectedIterations"
          />
          <AssigneeItemTooltip
            v-if="store.selectedAssignees.length"
            :assignees="store.selectedAssignees"
          />
          <ReporterItemTooltip
            v-if="store.selectedReporters.length"
            :reporters="store.selectedReporters"
          />
          <TeamItemTooltip v-if="store.selectedTeams.length" :teams="store.selectedTeams" />
          <ArtItemTooltip v-if="store.selectedArts.length" :arts="store.selectedArts" />
          <StatusItemTooltip v-if="store.selectedStatusItems.length" />
          <div v-if="store.showDependencyTeamFilter">
            {{ $t("general.teamDependencies") }}
            <div class="shortcut">
              {{ store.selectedDependencyFilterItem.name }}
            </div>
          </div>
          <RiskyLinksItemTooltip
            v-if="store.selectedRiskyLinks.length"
            :states="store.selectedRiskyLinks"
          />
          <UpperLevelLinksTooltip
            v-if="store.selectedUpperLevelLinks.type !== 'none'"
            :selection="store.selectedUpperLevelLinks"
          />
        </template>
      </template>
    </IconButton>
    <InfoMarker v-if="store.anyFilterCriteria" :top="5" :right="5" />
  </div>
</template>
